const home = require("@/assets/user/pages/home.html");
export default { 
  home,
};
